import { render } from "./SoftButtons.vue?vue&type=template&id=22b3a38b&ts=true"
import script from "./SoftButtons.vue?vue&type=script&lang=ts"
export * from "./SoftButtons.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__